// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__389rV","left":"StickyBox_left__2wFkK","right":"StickyBox_right__17f7p"};